import { VideoStandard } from "../../../../modules/video/components/VideoStandard/VideoStandard";
import type { IVideoBlockProps } from "./VideoBlock.props";

export const VideoBlock = (props: IVideoBlockProps) => {
  if (props.videoSource === "youtube") {
    if (!props.youtubeVideo) {
      return null;
    }

    return <VideoStandard {...props} source="youtube" url={props.youtubeVideo} />;
  }

  if (props.videoSource === "vimeo") {
    if (!props.vimeoVideo) {
      return null;
    }

    return <VideoStandard {...props} source="vimeo" url={props.vimeoVideo} />;
  }

  return null;
};

VideoBlock.displayName = "Block::VideoBlock";
